import { NomadDB } from '~/db/NomadDB.js';
import type { ChallengeSchema } from '@/types/schema';
export const getChallengesService = (db: NomadDB) => {
  const get = async (params: any): Promise<ChallengeSchema> => {
    return await db.challenges.get(params);
  };

  const findAll = async (): Promise<ChallengeSchema[]> => {
    const challenges = await db.challenges.toArray();
    return challenges;
  };

  return {
    get,
    findAll,
  };
};
